// Import 3rd party libraries
import {gsap} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Calculates the Y position of the headline
 *
 * @returns {number} The Y position of the headline
 */
const calcHeadlineY = () => {
    let defaultFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    let h1Height = document.querySelector("#headline h1").offsetHeight;
    let heroHeight = document.querySelector("#hero").offsetHeight - (12.5 * defaultFontSize) - 118 - (15 * defaultFontSize);
    let spacing = h1Height < heroHeight ? 15 : 6;

    return -(h1Height + (spacing * defaultFontSize));
}

export default function() {
    const matches = {
        isMobile: "(max-width: 480px)",
        isFoldable: "(max-width: 320px), (max-height: 480px)",
        isAny: "(min-width: 0px)", // There is a bug that requires at least one min width query
        reduceMotion: "(prefers-reduced-motion: reduce)"
    }

    gsap.matchMedia().add(matches, (context) => {
        let video = document.getElementById("hero--video");
        let isReducedMotion = context.conditions.reduceMotion;
        let isMobile = context.conditions.isMobile;
        let isFoldable = context.conditions.isFoldable;

        /**
         * Pause/Play the video when it is no longer in view
         *
         * The hero video uses fixed positioning, this means it will
         * always be within the window view and will never stop playing.
         * Manually pause/play the video when it is no longer in visible to
         * prevent CPU drain.
         */
        ScrollTrigger.create({
            trigger: "#headline",
            start: "bottom 0%",
            end: "top 100%",
            onEnter: () => video.pause(),
            onEnterBack: () => {
                if(!isReducedMotion)
                    video.play();
            },
        });


        /**
         * Move the headline to the hero section then slide it
         * down as the user scrolls.
         */
        // gsap won't properly animate y if the element has a transform set
        let headline = document.querySelector("#headline h1");
        headline.style.transform = 'unset';


        gsap.from("#headline h1", {
            scrollTrigger: {
                trigger: "#headline",
                start: "clamp(top, bottom)",
                end: "clamp(top, 50%)",
                toggleActions: "restart pause reverse pause",
                scrub: .5,
            },
            y: calcHeadlineY,
            ease: "none",
        });

        gsap.to("#headline h1", {
            scrollTrigger: {
                trigger: "#headline",
                start: "clamp(top, bottom)",
                end: "clamp(top, 50%)",
                toggleActions: "restart pause reverse pause",
                scrub: .5,
            },
            fontSize: isMobile ? isFoldable ? "3.4rem" : "4.3rem" : "5rem",
            ease: "none",
        });
    });
}